"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ValidationFailureOnStripeError extends client_library_1.ExtendableError {
    constructor() {
        super(`ValidationFailureOnStripeError`);
    }
}
exports.default = ValidationFailureOnStripeError;
//# sourceMappingURL=ValidationFailureOnStripeError.js.map